export default __webpack_public_path__ + "static/media/weather-big.e5bdd4fc.jpg";